import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/taggedTemplateLiteralLoose";
var _excluded = ["children"];
var _templateObject, _templateObject2, _templateObject3;
import { Fragment, useState } from 'react';
import styled, { css, createGlobalStyle } from 'styled-components';
import copyTextToClipboard from '@uiw/copy-to-clipboard';
import { useTranslation } from 'react-i18next';
import { CopyIcon } from './Icon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var GlobalStyle = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  [data-color-mode*='dark'], [data-color-mode*='dark'] body {\n    --color-button-bg: #30363d;\n  }\n  [data-color-mode*='light'], [data-color-mode*='light'] body {\n    --color-button-bg: #dae0e6;\n  }\n"])));
export var Button = props => /*#__PURE__*/_jsxs(Fragment, {
  children: [/*#__PURE__*/_jsx(GlobalStyle, {}), /*#__PURE__*/_jsx(ButtonBase, _extends({}, props))]
});
export var ButtonBase = styled.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  border: 0;\n  padding: 4px 6px;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: all 0.3s;\n  & > * {\n    vertical-align: middle;\n  }\n  ", "\n  &:hover {\n    background-color: var(--color-button-bg);\n  }\n  &.active {\n    background: #28a745;\n    color: white;\n  }\n  &:active,\n  &:focus {\n    box-shadow: 0px 0px 0px 2px rgb(0 0 0 / 17%);\n  }\n"])), props => props.success && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      background: #28a745;\n      color: white;\n    "]))));
export var CopyButton = _ref => {
  var other = _objectWithoutPropertiesLoose(_ref, _excluded);
  var {
    t
  } = useTranslation(['common']);
  var [success, setSuccess] = useState(false);
  var [type, setType] = useState('copy');
  function handleClick(evn) {
    copyTextToClipboard("" + other.value, isCopy => {
      setSuccess(true);
      setType('copied');
      var timer = setTimeout(() => {
        setSuccess(false);
        setType('copy');
        clearTimeout(timer);
      }, 2000);
    });
  }
  return /*#__PURE__*/_jsxs(Button, _extends({}, other, {
    success: success,
    className: success ? 'active' : '',
    onClick: handleClick,
    children: [/*#__PURE__*/_jsx(CopyIcon, {
      style: {
        marginRight: 2
      }
    }), /*#__PURE__*/_jsx("span", {
      children: type === 'copy' ? t('Copy', {
        ns: 'common'
      }) : t('Copied', {
        ns: 'common'
      })
    })]
  }));
};